export const UPDATESIMULATEUROBJECT = '@simulateur/updateSimulateurObject';

export function setSimulateurObject(data) {
    return {
        type: UPDATESIMULATEUROBJECT,
        payload: data
    };
}
